import React from "react";
import img1 from "../../img/feb_icon.png";

export default function HTML_Page_Title() {
  return (
    <div className="tutorial-container">
      {/* 🔹 Title */}
      <h1 className="tutorial-title">📘 HTML Page Title</h1>

      {/* 🔹 Introduction */}
      <p className="tutorial-intro">
        The <strong>HTML Page Title</strong> defines the text shown on the
        browser tab, bookmarks, and search engine results. It is written inside
        the <code className="highlight_code_1">&lt;title&gt;</code> tag within
        the
        <code className="highlight_code_1">&lt;head&gt;</code> section.
      </p>

      {/* 🔹 What Is Page Title */}
      <div
        className="Key_point_container"
        style={{
          background: "linear-gradient(135deg, #fef3c7, #fdba74)",
          borderRadius: "12px",
          padding: "1rem",
          marginBottom: "1.5rem",
        }}
      >
        <h3
          style={{
            color: "#c2410c",
            fontWeight: 700,
            fontSize: "1.5rem",
            marginBottom: "0.5rem",
          }}
        >
          📌 What Is an HTML Page Title?
        </h3>

        <ul className="tutorial-list-points">
          <li>Displayed on the browser tab</li>
          <li>Used by search engines for ranking</li>
          <li>Appears when page is bookmarked</li>
          <li>Improves SEO and user experience</li>
        </ul>
      </div>
      <img src={img1} alt="favicon example" style={{ width: "100%" }} />
      {/* 1️⃣ Basic Title */}
      <div className="tutorial-box">
        <h2>1️⃣ Basic HTML Page Title</h2>
        <p>
          The title of the page is written inside the
          <code className="highlight_code_1">&lt;head&gt;</code> section.
        </p>
        <div className="code-demo-box">
          <pre className="code-block">
            {`<html>
  <head>
    <title>My Website</title>
  </head>
  <body>
    <h1>Welcome!</h1>
  </body>
</html>`}
          </pre>
        </div>
      </div>

      {/* 2️⃣ Long & SEO Friendly Title */}
      <div className="tutorial-box">
        <h2>2️⃣ SEO-Friendly Page Title</h2>
        <p>Good titles are short, clear, and keyword-rich.</p>
        <div className="code-demo-box">
          <pre className="code-block">
            {`<title>HTML Tutorial for Beginners | Learn HTML Step by Step</title>`}
          </pre>
        </div>
      </div>

      {/* 3️⃣ Dynamic Title (JavaScript) */}
      <div className="tutorial-box">
        <h2>3️⃣ Change Title Using JavaScript</h2>
        <p>You can change the page title dynamically using JavaScript.</p>
        <div className="code-demo-box">
          <pre className="code-block">
            {`<script>
  document.title = "New Title from JavaScript!";
</script>`}
          </pre>
        </div>
      </div>

      {/* 4️⃣ React Dynamic Title */}
      <div className="tutorial-box">
        <h2>4️⃣ Setting Title in React</h2>
        <p>
          In React, you can set the title inside{" "}
          <code className="highlight_code_1">useEffect()</code>.
        </p>
        <div className="code-demo-box">
          <pre className="code-block">
            {`useEffect(() => {
  document.title = "React Page Title";
}, []);`}
          </pre>
        </div>
      </div>

      {/* 5️⃣ Using React Helmet */}
      <div className="tutorial-box">
        <h2>5️⃣ React Helmet — Best Method</h2>
        <p>
          React Helmet is used for SEO-friendly page titles in React
          applications.
        </p>
        <div className="code-demo-box">
          <pre className="code-block">
            {`import { Helmet } from "react-helmet";

function App() {
  return (
    <>
      <Helmet>
        <title>Helmet Page Title</title>
      </Helmet>
      <h1>Hello</h1>
    </>
  );
}`}
          </pre>
        </div>
      </div>

      {/* Summary */}
      <div
        style={{
          background: "linear-gradient(135deg, #d1fae5, #6ee7b7)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2>📘 Summary — HTML Page Title</h2>
        <ul className="tutorial-list-points">
          <li>
            Written inside{" "}
            <code className="highlight_code_1">&lt;title&gt;</code> tag
          </li>
          <li>Shown in browser tab and bookmarks</li>
          <li>Important for SEO</li>
          <li>Can be changed dynamically with JavaScript or React</li>
          <li>React Helmet is best for SEO apps</li>
        </ul>
      </div>
    </div>
  );
}
